import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import amarilloImg from "../../../assets/images/equipoAmarillo.png";
import verdeImg from "../../../assets/images/equipoVerde.png";

function Equipos() {

  return (
    <>
      <Card>
        <Card.Body style={{ color: '', textAlign: 'center', padding: '10px 20px', }}>
          <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
            Nuestros Equipos
          </Card.Text>
        </Card.Body>
      </Card>
      <Container className="d-flex justify-content-center align-items-center flex-column mt-5" data-aos="fade-up">
        <Row className="g-4 justify-content-center mb-5">
          <Col xs="auto">
            <Card className='shadow-lg texto-animado' style={{ width: '25rem', borderRadius: '12px' }}>
              <Card.Img variant="top" src={amarilloImg} />
              <Card.Body>
                <Card.Title id="titleStyle" >Equipo Amarillo</Card.Title>
                <Card.Text className='fw-bold text-center'>
                  Simboliza la energía, la alegría y la creatividad. Es reconocido por su espíritu participativo y trabajo en equipo.
                </Card.Text>
                <div className="text-center">
                  <Button variant="warning fw-bold">Ver más</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs="auto">
            <Card className='shadow-lg texto-animado' style={{ width: '25rem', borderRadius: '12px' }}>
              <Card.Img variant="top" src={verdeImg} />
              <Card.Body>
                <Card.Title id="titleStyle" >Equipo Verde</Card.Title>
                <Card.Text className='fw-bold text-center'>
                  Representa la esperanza, la armonía y el crecimiento. Participa en todas las actividades deportivas y culturales.
                </Card.Text>
                <div className="text-center">
                  <Button variant="success fw-bold">Ver más</Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Equipos;
